import React, { useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { DomainContext } from '../context';
import { isUserAuthenticated } from '../utils/tokenManager';
import UserContext from '../context/userContext';
import { isBillingOnlyUser } from '../utils/userUtils';
import { FeatureUsageContext } from '../context/featureUsageContext';
interface User {
    id: number;
    iat: number;
    exp: number;
}
const isUnauthenticatedUser = (user: User | null, hasLandingPage: boolean, pathname: string) => {
    return !user && !(hasLandingPage && pathname === '/');
};

const isBillingUserAllowed = (pathname: string, hash: string) => {
    return pathname === '/settings' && hash === '#billing';
};

// biome-ignore lint/suspicious/noExplicitAny: legacy code
const ProtectedRoute: React.FC<RouteProps & { component: React.ComponentType<any> }> = ({
    component: Component,
    ...rest
}) => {
    const domainContextValue = useContext(DomainContext);
    const hasLandingPage = domainContextValue?.domainData?.hasLandingPage;
    const { user } = isUserAuthenticated();
    const clientUser = useContext(UserContext);
    const { clientPlan } = useContext(FeatureUsageContext);

    return (
        <Route
            {...rest}
            render={(props) => {
                const { pathname, hash } = props.location;

                if (isUnauthenticatedUser(user, !!hasLandingPage, pathname)) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: props.location },
                            }}
                        />
                    );
                }
                if (
                    isBillingOnlyUser(clientUser, clientPlan) &&
                    !isBillingUserAllowed(pathname, hash)
                ) {
                    return <Redirect to='/settings#billing' />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default ProtectedRoute;
